// Плашка Garmin на всех экранах: вход устарел или синхронизации нет больше 6 часов.

import { Link, useLocation } from 'react-router-dom'

import { Icon } from '@/components/ui/Icon'

import { useGarminStatus } from './api'

export function Banner() {
  const status = useGarminStatus()
  const { pathname } = useLocation()
  const banner = status.data?.banner
  if (!banner) return null
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b border-warning/30 bg-warning-soft px-4 py-2 text-sm text-warning"
    >
      <Icon name="alert" size={16} />
      <span>{banner.message}</span>
      {pathname !== '/settings/garmin' ? (
        <Link to="/settings/garmin" className="font-medium underline underline-offset-2">
          {banner.kind === 'expired' ? 'Войти заново' : 'Открыть настройки Garmin'}
        </Link>
      ) : null}
    </div>
  )
}
